export function initRAnchorHandler() {
  const elements = document.querySelectorAll('[data-r-anchor-link]');

  if (!elements.length) {
    return;
  }

  const handler = (event) => {
    event.preventDefault();
    const target = document.querySelector(event.currentTarget.getAttribute('href'));
    if (target) {
      let offsetTop;

      if (window.innerWidth < 1024) {
        offsetTop = target.offsetTop;
      } else {
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        offsetTop = target.offsetTop - headerHeight;
      }

      window.scrollTo({
        top      : offsetTop,
        behavior : 'smooth'
      });
    }
  };

  elements.forEach((el) => el.addEventListener('click', handler));
}
